import React from 'react';
import { UserSidebar } from '../components/UserSidebar';
import { CompanySideBar } from '../components/CompanySideBar';
import { useAuthStore } from '../store';

export function UserDashboardLayout({ children }) {
    const { auth } = useAuthStore();
    const isCompany = auth.user?.tipoPerfil === 'EMPRESA';
    const isPendingCompany = isCompany && auth.user?.estado === 'PENDIENTE';

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white browse-job p-t50 p-b20">
                    <div className="container">
                        {/* Alerta destacada de cuenta pendiente para empresas - Arriba de todo */}
                        {isPendingCompany && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div 
                                        style={{
                                            backgroundColor: '#fff3cd',
                                            border: '2px solid #ffc107',
                                            borderRadius: '8px',
                                            padding: '20px 25px',
                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <i 
                                                className="fa fa-exclamation-triangle" 
                                                style={{ 
                                                    fontSize: '32px', 
                                                    color: '#ff9800', 
                                                    marginRight: '15px',
                                                    marginTop: '5px'
                                                }}
                                            ></i>
                                            <div style={{ flex: 1 }}>
                                                <h4 style={{ 
                                                    color: '#856404', 
                                                    fontWeight: 'bold',
                                                    marginBottom: '10px',
                                                    fontSize: '20px'
                                                }}>
                                                    ⚠️ Cuenta Pendiente de Aprobación
                                                </h4>
                                                <p style={{ 
                                                    color: '#856404', 
                                                    marginBottom: '10px',
                                                    fontSize: '15px',
                                                    lineHeight: '1.6'
                                                }}>
                                                    Tu cuenta de empresa está siendo revisada por nuestro equipo de administración. 
                                                </p>
                                                <div style={{
                                                    backgroundColor: 'rgba(255, 193, 7, 0.1)',
                                                    padding: '12px',
                                                    borderRadius: '5px',
                                                    marginTop: '10px'
                                                }}>
                                                    <p style={{ 
                                                        color: '#856404', 
                                                        marginBottom: '5px',
                                                        fontWeight: '600'
                                                    }}>
                                                        <strong>Funciones disponibles:</strong>
                                                    </p>
                                                    <ul style={{ 
                                                        marginBottom: '0', 
                                                        paddingLeft: '20px',
                                                        color: '#856404'
                                                    }}>
                                                        <li>✅ Ver y buscar vacantes</li>
                                                        <li>✅ Editar tu perfil de empresa</li>
                                                        <li>✅ Cambiar contraseña</li>
                                                    </ul>
                                                    <p style={{ 
                                                        color: '#856404', 
                                                        marginTop: '10px',
                                                        marginBottom: '0',
                                                        fontWeight: '600'
                                                    }}>
                                                        <strong>Funciones bloqueadas:</strong>
                                                    </p>
                                                    <ul style={{ 
                                                        marginBottom: '0', 
                                                        paddingLeft: '20px',
                                                        color: '#856404'
                                                    }}>
                                                        <li>🚫 Publicar vacantes</li>
                                                        <li>🚫 Administrar vacantes</li>
                                                        <li>🚫 Ver postulaciones</li>
                                                    </ul>
                                                </div>
                                                <p style={{ 
                                                    color: '#856404', 
                                                    marginTop: '15px',
                                                    marginBottom: '0',
                                                    fontSize: '14px',
                                                    fontStyle: 'italic'
                                                }}>
                                                    Una vez aprobada tu cuenta, tendrás acceso completo a todas las funcionalidades.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        <div className="row">
                            {isCompany ? <CompanySideBar /> : <UserSidebar />}
                            <div className="col-xl-9 col-lg-8 m-b30">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
